import * as z from "zod";

export { ftthOrchestrator as serverResponse } from "@nju/data-access-portal-orchestrator";

export const verificationErrorResponse = z.object({
  code: z.literal("50137").or(z.literal("50138")),
});
